import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

//  Get All
export const findAll = createAsyncThunk(
  "masters/funtargetbet/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.FunTarget.control}/control/bets?name=${filter?.name || ""}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const ChangeResult = createAsyncThunk(
  "masters/funtargetbet/control",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.FunTarget.control}/control/change/${id}`,
        data,
      );
      if (res?.success) return res;
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Slice = createSlice({
  name: "bet",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(findAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(findAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(findAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });

    // .addCase(ChangeResult.pending, (state) => {
    //   state.status = IDS.SLICESTATUS.Loading;
    // })
    // .addCase(ChangeResult.fulfilled, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Succeeded;
    //   // state.data = action.payload;
    //   const index = state.data.findIndex(
    //     (country) => country.id === action.payload?.data?.id,
    //   );
    //   if (index !== -1) {
    //     state.data[index] = action.payload.data;
    //   }
    // })
    // .addCase(ChangeResult.rejected, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Failed;
    //   state.error = action.payload;
    // });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
